/**
 * define configuration options here
 */

export const url = {
	protocol : "http",
	hostname : "localhost",
	port : "8000",
	api_base_path: "/"
};

export const momentDateFormat = "Do MMM YYYY";
export const momentDateTimeFormat = "hh:mm Do MMM YYYY";
export const momentDateTimeFormat1 = "hh:mm A Do MMM YYYY";

export const demo = false;

